module.exports = __webpack_public_path__ + "img/op_como-funciona-relink-2.640d384.png";